import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import localeEn from '@angular/common/locales/en-GB';
import localeEnExtra from '@angular/common/locales/extra/en-GB';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import {
  ApiModule,
  BASE_META_REDUCERS,
  BASE_REDUCERS,
  BaseModule,
  BaseSharedModule,
  ENVIRONMENT,
  ENVIRONMENTER,
  baseTranslateLoaderFactory,
  AUTH_BOOTSTRAP_INITIALIZER_PROVIDER,
  UP_TO_DATE_INITIALIZER_PROVIDER,
  PORTAL_SETTINGS_INITIALIZER_PROVIDER,
  PORTAL_SETTINGS_PROVIDER,
} from 'base';
import { BaseCustomerModule } from 'base-customer';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutModule } from './layout/layout.module';

registerLocaleData(localeDe, 'de', localeDeExtra);
registerLocaleData(localeEn, 'en', localeEnExtra);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BaseSharedModule,
    BaseModule,
    BaseCustomerModule,
    LayoutModule,
    AppRoutingModule,
    ApiModule.forRoot({ rootUrl: environment.global.apiUrl }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: baseTranslateLoaderFactory,
        deps: [HttpClient],
      },
      defaultLanguage: 'de',
    }),
    StoreModule.forRoot(BASE_REDUCERS, {
      metaReducers: BASE_META_REDUCERS,
      runtimeChecks: { strictStateImmutability: true, strictActionImmutability: true },
    }),
    StoreRouterConnectingModule.forRoot(),
    EffectsModule.forRoot([]),
    !environment.global.production
      ? StoreDevtoolsModule.instrument({
          maxAge: 25, //  Retains last 25 states
        })
      : [],
  ],
  providers: [
    { provide: ENVIRONMENT, useValue: environment },
    { provide: ENVIRONMENTER, useValue: environment },
    { provide: LOCALE_ID, useValue: 'de' },
    ...(environment.global.production || environment.global.staging || environment.global.demo
      ? [UP_TO_DATE_INITIALIZER_PROVIDER]
      : []),
    AUTH_BOOTSTRAP_INITIALIZER_PROVIDER,
    PORTAL_SETTINGS_INITIALIZER_PROVIDER,
    PORTAL_SETTINGS_PROVIDER,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
